/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_2_QInputs */

const en_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is an ATS score and why does it matter?`)
};

const de_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist ein ATS-Score und warum ist er wichtig?`)
};

const fr_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'un score ATS et pourquoi est-il important ?`)
};

const es_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que es una puntuacion ATS y por que es importante?`)
};

const it_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'e un punteggio ATS e perche e importante?`)
};

const nl_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een ATS-score en waarom is het belangrijk?`)
};

const pl_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czym jest wynik ATS i dlaczego jest wazny?`)
};

const fi_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mika on ATS-pistemäärä ja miksi silla on merkitysta?`)
};

const da_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad er en ATS-score, og hvorfor er den vigtig?`)
};

const sv_landing_faq_2_q = /** @type {(inputs: Landing_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad aer en ATS-poaeng och varfoer aer den viktig?`)
};

/**
* | output |
* | --- |
* | "What is an ATS score and why does it matter?" |
*
* @param {Landing_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_2_q = /** @type {((inputs?: Landing_Faq_2_QInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_2_QInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_2_q(inputs)
	if (locale === "fr") return fr_landing_faq_2_q(inputs)
	if (locale === "es") return es_landing_faq_2_q(inputs)
	if (locale === "it") return it_landing_faq_2_q(inputs)
	if (locale === "nl") return nl_landing_faq_2_q(inputs)
	if (locale === "pl") return pl_landing_faq_2_q(inputs)
	if (locale === "fi") return fi_landing_faq_2_q(inputs)
	if (locale === "da") return da_landing_faq_2_q(inputs)
	if (locale === "sv") return sv_landing_faq_2_q(inputs)
	return en_landing_faq_2_q(inputs)
});